import React, { useState, useEffect } from "react";

//components
import { LabsResult, StudiesResult } from "../Results";

//call Action
// import { atcClickResult } from "@actions";

//redux
import { useSelector } from "react-redux";

//react-router-dom
// import { useParams } from "react-router-dom";

function ListTabsResult(props) {
    // let { id } = useParams();
    // const dispatch = useDispatch();

    //props 
    const { arrDotResult } = props && props;
    const caseData = useSelector((state) => state.cases || []);
    const TaskRecords = caseData?.data?.Case?.TaskRecords;

    //state
    const [activeTab, setActiveTab] = useState(0); // Mặc định là tab đầu tiên (0)
    const [statusDot, setStatusDot] = useState(arrDotResult);

    //load status
    useEffect(() => {
        setStatusDot(arrDotResult);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //Hidden When click
    const handleClickHideDot = (type, index) => {
        // const params = {
        //     "Task": type === "Labs" ? "view_lab" : "view_study"
        // }
        // dispatch(atcClickResult(params, id));
        setActiveTab(index);
    }

    //Handle Tabs
    const handleTab = (tab) => {
        setActiveTab(tab);
    };

    const navListGroup = [
        {
            Name: "Labs",
            Component: <LabsResult {...props} />,
            Icon: `icon-labs-2`,
            Type: 'Labs'
        },
        {
            Name: "Studies",
            Component: <StudiesResult {...props} />,
            Icon: `icon-exam-2`,
            Type: 'Studies'
        }
    ];
    
    return (
        <React.Fragment>
            <ul className="tabs-corner">
                {navListGroup?.map((value, index) => (
                    <li
                        className={`tabs-corner__item ${activeTab === index ? 'active' : ''}`} // So sánh với index
                        key={index}
                        onClick={() => handleTab(index)} // Truyền index thay vì chuỗi
                        data-type={value?.Type}
                    >
                        {statusDot?.Studies && value?.Type === 'Studies' && !TaskRecords?.StudyResultViewed &&
                            <span className="notic_dot"></span>
                        }
                        {statusDot?.Labs && value?.Type === 'Labs' && !TaskRecords?.LabResultViewed &&
                            <span className="notic_dot"></span>
                        }
                        <div className="eventHiddenDot" onClick={() => handleClickHideDot(value?.Type, index)}></div>
                        <span className="tabs-corner__item--text">{value.Name}</span>
                        <span className={`tabs-corner__item--icon ${value?.Icon}`}></span>
                    </li>
                ))}
            </ul>
            <div className="result-tab-content">
                {navListGroup?.map((value, index) => (
                    <div key={index} className={`${activeTab === index ? 'd-block' : 'd-none'}`}> {/* So sánh với index */}
                        {value?.Component}
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
}

export default ListTabsResult;